import { render, staticRenderFns } from "./ContractDocumentsTab.vue?vue&type=template&id=63bc25ef&scoped=true"
import script from "./ContractDocumentsTab.vue?vue&type=script&lang=js"
export * from "./ContractDocumentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc25ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bc25ef')) {
      api.createRecord('63bc25ef', component.options)
    } else {
      api.reload('63bc25ef', component.options)
    }
    module.hot.accept("./ContractDocumentsTab.vue?vue&type=template&id=63bc25ef&scoped=true", function () {
      api.rerender('63bc25ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/tabs/ContractDocumentsTab.vue"
export default component.exports